import { useEffect, useState } from "react"
import { useSiteData } from "../../../context/fetchContext"

const defaultData = [
  { title: 'Home', location: '/' },
  { title: 'Services', location: '/services', },
  { title: 'Gallery', subItems: [] },
  { title: 'Blog', location: '/blog', },
  { title: 'About Us', location: '/about-us', },
]

const useMenuData = () => {
  const [menuData, setMenuData] = useState(defaultData)
  const { gallery } = useSiteData()

  useEffect(() => {
    setMenuData((prev) => {
      const newState = prev.map((data: any) => {
        if (data.title === 'Gallery') {
          const subItems = gallery.map(({ name, slug }) => ({
            title: name,
            location: `/services/${slug}`
          }))
          return {
            ...data,
            subItems
          }
        } else {
          return data
        }
      })

      return newState
    })
  }, [gallery])

  return menuData
}

export default useMenuData